import { render, staticRenderFns } from "./QuestionContinue.vue?vue&type=template&id=68f98d4e&scoped=true&"
import script from "./QuestionContinue.vue?vue&type=script&lang=js&"
export * from "./QuestionContinue.vue?vue&type=script&lang=js&"
import style0 from "./QuestionContinue.vue?vue&type=style&index=0&id=68f98d4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f98d4e",
  null
  
)

export default component.exports